import type { DeckIdentity } from "@/interfaces/DeckIdentity";
import { getCardData } from "@/lib/games/riftbound/getCardDataLocal";
import { RBItem } from "@/interfaces/CardItem";
import { getImgproxyUrl } from "@/lib/imgproxy";
import { gameAssetUrl } from "@/lib/cdn";

export function getLeaderImage(id: string): string {
  // Use CDN directly without imgproxy for archetype squares
  return gameAssetUrl("riftbound", "archetype-squares", `${id}.webp`, "1.0.7");
}

export function getArchetypeData(
  archetypeId: string,
): DeckIdentity | undefined {
  const cardData = getCardData(archetypeId) as RBItem | undefined;

  if (!cardData) {
    console.warn(`Riftbound card not found: ${archetypeId}`);
    return undefined;
  }

  let img = getLeaderImage(archetypeId);

  const curArchetype: DeckIdentity = {
    id: archetypeId,
    name: cardData.name,
    color: cardData.color,
    set: cardData.set,
    image: img,
  };

  return curArchetype;
}
